<template>
	<div class="expert-details">
		<div class="infoWrap">
			<expert-info :expertInfo="expertInfo"></expert-info>
			<div class="text-box" ref="textBox" :class="['jianjie', {'overflow-line':!unfold}]">
				<span ref="brief" v-show="expertInfo.des">简介: {{expertInfo.des}}</span>
			</div>
			<button v-show="ifOver" @click="unfold = !unfold">{{unfold ? '收起' : '查看更多'}}</button>
		</div>
		<div class="meetingList list" v-if="meetingList.length>0">
			<h1>全部作品</h1>
			<ul class="container">
				<li v-for="item in meetingList" :key="item.session_id" >
					<router-link :to="{path:'/meeting/live',query:{meeting_id:item.meeting_id,id:item.session_id}}">
						<img :src="item.session_banner" alt="">
						<div class="title">
							<h3>{{item.session_name}}</h3>
							<span>{{item.session_start_at}} - {{item.session_end_at}}</span>
						</div>
					</router-link>
				</li>
			</ul>
		</div>
	</div>
</template>
<script>
	import {ExpertInformation,ExpertSpeakersInfo} from '../../config/interface.js'
	import ExpertInfo from '../../components/Expert/ExpertInfo'
	import ItemBlock from '../../components/ItemBlock'
	import Return from '@/components/Meeting/Return'
	export default{
		components:{
			ExpertInfo,
			ItemBlock,
			Return
		},
		data(){
			return{
				unfold:false,		//文本展开状态  默认收起
				ifOver:false,		//文本是否超出三行  默认否
				writer_id:0,
				meeting_id:0,     //会议id
				expertInfo:{},    //专家信息
				meetingList:[],   //会议列表
				columnsList:[],   //专栏列表
				scheduleList:{},   //日程信息
			}
		},
		mounted(){
			this.writer_id=this.$route.query.id;
			this.getExpertInfo(this.writer_id);
			// 判断是否显示展开收起按钮
			setTimeout(() => {
    			this.ifOver = this.$refs.brief.offsetHeight > this.$refs.textBox.offsetHeight;
			}, 0)
		},
		methods:{
			// 获取专家信息  (withcolumns 为1时附带专家相关的专栏;withmeeting:为1时附带专家相关的会议;weekmeeting:不填写默认返回专家所有会议，为1 时返回近两周的会议)
			getExpertInfo(id){
				const url=ExpertInformation;
				const method='POST';
				let params={
					writer_id:id,
					withmeetings:1,
				}
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						this.expertInfo={
							photo:data.photo,
							name:data.name,
							company:data.company,
							positionName:data.title.name,
							des:data.des
						}
						data.meetings.forEach((item,index)=>{
							item.session_start_at=((item.session_start_at.split(' ')[0]).split('-')).join('.');
							let end_at_arr=(item.session_end_at.split(' ')[0]).split('-');
							item.session_end_at=end_at_arr[1]+'.'+end_at_arr[2];
						})
						this.meetingList=data.meetings;
					}
				})
			},
			showmoreDesc(){

			}
			// getExpertDetailInfo(){
			// 	this.$store.dispatch('isShowLoading',true);
			// 	const url=ExpertSpeakersInfo;
			// 	const method='POST';
			// 	let params={
			// 		meeting_id:this.$route.query.meeting_id,
			// 		writer_id:this.writer_id
			// 	}
			// 	fetch(url,params,method)
			// 	.then((res)=>{
			// 		if(res.code==0){
			// 			let data=res.data;
			// 			this.scheduleList=data;
			// 		}
			// 		this.$store.dispatch('isShowLoading',false);
			// 	})
			// }
		}
	}
</script>
<style lang="scss">
	.expert-details{
		background:#f8f8f8;
		height: 100%;
		.infoWrap{
			background: #fff;
			padding:5px 15px;
			.expertInfo-component{
				border:0px;
				.info{
					span{
						font-weight:700;
						color:$color-black;
					}
				}
			}
			.jianjie{
				text-align: justify;
				color:#333;
			}
			.jianjie.overflow-line{
				display: -webkit-box;
				-webkit-box-orient: vertical;
				-webkit-line-clamp: 3;
				overflow: hidden;
			}
			button{
				float:right;
				border:0px;
				color:#2386d5;
				background:#fff;
			}
		}
		.meetingList{
			
			h1{
				padding: 8px 13px;
    			font-size: 15px;
			}
			.container{
				padding:0 7px;
				display:flex;
				flex-wrap:wrap;
				li{
					width:50%;
					margin-bottom: 15px;
					a{
						background:#fff;
						display: block;
						margin:0 7px;
						border-radius: 5px;
						img{
							width:100%;
							border-radius: 5px 5px 0 0;
						}
						.title{
							padding:7px 4px;
						}
						h3{
							text-align: justify;
							font-size:12px;
							margin-bottom:5px;
							color:#444;
							overflow: hidden;
							-webkit-box-orient: vertical;
							-webkit-line-clamp: 1;
							display: -webkit-box;
							line-height: 16px;
						}
						span{
							color:#999;
							font-size:11px;
							
						}
					}
				}
			}
		}
		// .meetingSchedule{
		// 	.time{
		// 		color:#901d22;
		// 		.van-icon{
		// 			vertical-align:-2px;
		// 		}
		// 		padding:15px 15px;
		// 		font-size:20px;
		// 		border-bottom:1px solid #f4f4f4;
		// 	}
		// 	.step{
		// 		padding-left:15px;
		// 		>div{
		// 			padding:5px 0;
		// 		}
		// 		h3{
		// 			font-size: 17px;
		// 			line-height:35px;
		// 		}
		// 		p{
		// 			line-height:22px;
		// 			font-size:14px;
		// 			color:#9ea9c5;
		// 		}

		// 	}

		// }
		// .meetingSchedule:last-child{
		// 	.hr7{
		// 		background:#fff;
		// 	}
		// }
		// .list{
		// 	padding:0 15px;
		// 	.title{
		// 		padding:14px 0 0 0;
		// 		@include flex(row);
		// 		justify-content:space-between;
		// 		div{
		// 			b{
		// 				font-size:17px;
		// 				color:$color-black;
		// 			}
		// 			span{
		// 				margin-left:5px;
		// 				font-size:13px;
		// 				color:#3f3f3f;
		// 				letter-spacing:.6px;
		// 			}
		// 		}
		// 		a{
		// 			font-size:14px;
		// 			color:$color-main;
		// 		}
				
		// 	}
		// 	.item-block:last-child{
		// 		border:0px;
		// 	}
		// }
	}
</style>


// WEBPACK FOOTER //
// src/pages/Expert/Details.vue